// extracted by mini-css-extract-plugin
export var bodyRow = "_cn-d";
export var cardColumns = "_cn-e";
export var ellipsesOverflow = "_cn-2";
export var flatBottomCorners = "_cn-3";
export var flatTopCorners = "_cn-4";
export var headerActionsDropdown = "_cn-f";
export var headerBottomRow = "_cn-c";
export var headerTopRow = "_cn-b";
export var orderDetailsWrapper = "_cn-0";
export var orderInfoContainer = "_cn-1";
export var productDetails = "_cn-9";
export var productImage = "_cn-5";
export var responsiveTable = "_cn-8";
export var shipmentContainer = "_cn-a";
export var tableBottomLeft = "_cn-6";
export var tableBottomRight = "_cn-7";
export var trackingLink = "_cn-g";